<template>
  <metainfo></metainfo>

  <div class="page-header d-print-none">
    <div class="container-xl">
      <div class="row g-2 align-items-center">
        <div class="col">
          <h2 class="page-title">
            Каналы
          </h2>
        </div>
      </div>
    </div>
  </div>
  <div class="page-body" id="channels">
    <div class="container-xl">
      <div class="row row-cards">
        <div class="col-lg-4" v-for="channel of channels" :key="channel.id">
          <div
              class="card"
              role="link"
              @click="$router.push({ name: 'Posts', params: { channel_id: channel.id } })"
          >
            <div class="card-body">
              <div class="row align-items-center">
                <div class="col-auto">
                  <span class="avatar avatar-xl avatar-rounded" :style="{backgroundImage: 'url(/assets/static/channels/'+ channel.img +')'}"></span>
                </div>
                <div class="col">
                  <h3 class="card-title mb-1">
                    <div class="text-reset">{{ channel.name }}</div>
                    <span class="me-1 el" v-show="showCommentsCount[channel.id]">
                      <CommentCount :data="{
                        channel_id: channel.id
                      }" @update:visible="val => showCommentsCount[channel.id] = val"/>
                    </span>
                    <template v-if="channel.id === 1">
                       <span class="me-1 el" v-show="showPostModerationCount[channel.id]" @click.stop>
                        <CountPostModeration :payload="{
                          channel_id: channel.id,
                          type_visible: 1,
                        }" @update:visible="val => showPostModerationCount[channel.id] = val"/>
                       </span>
                    </template>
                    <template v-if="channel.id === 1">
                      <span class="me-1 el" v-show="showPromocodeNewCount[channel.id]">
                        <CountPromocodeNew :payload="{
                          level: 'green',
                        }" @update:visible="val => {showPromocodeNewCount[channel.id] = val}"/>
                      </span>
                    </template>
                    <span v-if="channel.id === 1">
                      <span class="me-1 el" v-show="showPromocodeDeleteCount[channel.id]">
                        <CountPromocodeDelete :payload="{}"
                          @update:visible="val => showPromocodeDeleteCount[channel.id] = val"/>
                      </span>
                    </span>
                  </h3>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-4">
          <router-link class="card" :to="{name: 'PromopushkaCouponItems'}">
            <div class="card-body">
              <div class="row align-items-center">
                <div class="col-auto">
                  <span class="avatar avatar-xl avatar-rounded" :style="{backgroundImage: 'url(/assets/static/promopushka/logo.jpg)'}"></span>
                </div>
                <div class="col">
                  <h3 class="card-title mb-1">
                    <div class="text-reset">Промопушка</div>
                    <CommentCount :data="{
                      channel_id: 13,
                    }"/>
                  </h3>
                </div>
              </div>
            </div>
          </router-link>
        </div>
        <div class="col-lg-4" v-if="false">
          <router-link class="card" :to="{name: 'WishlistWishes'}">
            <div class="card-body">
              <div class="row align-items-center">
                <div class="col-auto">
                  <span class="avatar avatar-xl avatar-rounded" :style="{backgroundImage: 'url(/assets/static/wishlist.jpg)'}"></span>
                </div>
                <div class="col">
                  <h3 class="card-title mb-1">
                    <span class="text-reset">Вишлисты</span>
                  </h3>
                </div>
              </div>
            </div>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CommentCount from "../components/comment_count/CommentCount"
import CountPromocodeNew from "../components/count_promocode_new/Index"
import CountPromocodeDelete from "../components/count_promocode_delete/Index"
import {defineComponent, onMounted, reactive} from "vue"
import {fill as commentCountFill} from "../components/comment_count/services/base"
import {useMeta} from "vue-meta"
import CountPostModeration from "../components/count_post_moderation/Index"

export default defineComponent({
  name: "Channels",
  components: {
    CountPostModeration,
    CommentCount,
    CountPromocodeNew,
    CountPromocodeDelete,
  },
  setup() {
    useMeta({title: "Каналы"})

    let channels = [
      {
        name: "Сайт",
        img: "site.jpg",
        id: 1,
      },
      {
        name: "Молния",
        img: "molniya.jpg",
        id: 3,
      },
      {
        name: "Aliexpress",
        img: "ali.jpg",
        id: 4,
      },
      {
        name: "Халявщики",
        img: "hlv.jpg",
        id: 2,
      },
      {
        name: "Travel",
        img: "travel.jpg",
        id: 7,
      },
      {
        name: "Live",
        img: "live.jpg",
        id: 9,
      },
      {
        name: "Нашли дешевле",
        img: "cheaper.jpg",
        id: 8,
      },
      {
        name: "DailySales",
        img: "daily.jpg",
        id: 5,
      },
      {
        name: "Эконом",
        img: "econom.jpg",
        id: 10,
      },
      {
        name: "Haunt",
        img: "haunt.jpg",
        id: 11,
      },
      {
        name: "Ultima",
        img: "ultima.jpg",
        id: 12,
      },
    ]

    const showCommentsCount = reactive({})
    const showPromocodeNewCount = reactive({})
    const showPromocodeDeleteCount = reactive({})
    const showPostModerationCount = reactive({})

    onMounted(() => {
      loadFinal()
    })

    function loadFinal() {
      commentCountFill([
        1,2,3,4,5,6,7,8,9,10,11,12,13,
      ], {
        only_moderate: true,
        is_private: false,
      })
    }

    return {
      channels,
      showCommentsCount,
      showPromocodeNewCount,
      showPromocodeDeleteCount,
      showPostModerationCount,
    }
  }
})
</script>

<style scoped>
  #channels .el:hover {
    cursor: pointer;
  }

  #channels .card {
    cursor: pointer;
  }
</style>
